/*
 * Row-selection behaviour shared by the Client, Lender and Manual lanes.
 *
 * This file was `lanePinning.ts` and also held `pinSelected` (lift the open
 * task to row 1) and `useDeselectRestore` (scroll the row back into view once
 * it dropped again). Both were removed on 2026-08-27 along with the per-user
 * `lanePinnedTasks` preference that gated them: rows now stay exactly where
 * they are in the list, and the only thing left is closing an open task by
 * clicking it again.
 *
 * `enabled` flags went with the preference -- there is one behaviour for
 * everyone now, so the helper below is unconditional.
 */

/**
 * Click handler for a row: clicking the already-open task closes it, so the
 * reading pane can be dismissed from the list as well as from the pane itself.
 */
export function toggleSelect(
  selectedTaskId: string | null,
  taskId: string,
  onSelectTask: (id: string | null) => void,
): void {
  onSelectTask(selectedTaskId === taskId ? null : taskId);
}
